import {ICashBackHistory} from '../api/getCashBackHistoryList/cashBackHistory.types';

export enum CashBackTransactionType {
  Purchase = 1,
  Usage = 2,
  Cancel = 3,
  Reserve = 4,
  AdminCredit = 5,
  Reject = 6,
}

export const cashBackIncreaseStatus = [
  CashBackTransactionType.Purchase,
  CashBackTransactionType.Cancel,
  CashBackTransactionType.AdminCredit,
  CashBackTransactionType.Reject,
];

export const cashBackDecreaseStatus = [
  CashBackTransactionType.Usage,
  CashBackTransactionType.Reserve,
];

type TransactionDirection = 'increase' | 'decrease' | 'neutral';

interface ITransactionPresentation {
  direction: TransactionDirection;
  amountLabel: string;
  dateLabel: string;
  containerClassName: string;
  amountClassName: string;
}

export const getCashBackTransactionDescription = (
  transaction: ICashBackHistory,
): string => {
  switch (transaction.transaction_type) {
    case CashBackTransactionType.Usage:
      return 'خرید از فروشگاه';

    case CashBackTransactionType.Reserve:
      return 'در انتظار تأیید ادمین';

    case CashBackTransactionType.Purchase:
      return ` ${transaction.rate.toLocaleString(
        'fa-IR',
      )}٪ افزایش بابت خرید نقدی`;

    case CashBackTransactionType.Cancel:
      return 'لغو شدن سفارش فروشگاه';

    case CashBackTransactionType.AdminCredit:
      return 'دریافت اعتبار از سامانه مزرعه';

    case CashBackTransactionType.Reject:
      return 'رد شدن خرید توسط مزرعه';

    default:
      return '—';
  }
};

export const getCashBackTransactionPresentation = (
  transactionType: CashBackTransactionType,
): ITransactionPresentation => {
  const isIncrease = cashBackIncreaseStatus.includes(transactionType);
  const isDecrease = cashBackDecreaseStatus.includes(transactionType);

  if (isIncrease) {
    return {
      direction: 'increase',
      amountLabel: 'مبلغ افزایش',
      dateLabel: 'تاریخ افزایش',
      containerClassName: 'bg-[#f8fcf4]',
      amountClassName: 'text-farm-shop-500',
    };
  }

  if (isDecrease) {
    return {
      direction: 'decrease',
      amountLabel: 'مبلغ کاهش',
      dateLabel: 'تاریخ کاهش',
      containerClassName: 'bg-[#fffafa]',
      amountClassName: 'text-red-500',
    };
  }

  return {
    direction: 'neutral',
    amountLabel: 'مبلغ تراکنش',
    dateLabel: 'تاریخ تراکنش',
    containerClassName: 'bg-gray-50',
    amountClassName: 'text-gray-600',
  };
};
